import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { uiState } from 'react-redux-ui-state';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import PersonAdd from '@material-ui/icons/PersonAdd';

import { handleClickAway } from 'services/handleClickAway';
import AddUserFormContainer from 'components/AddUserForm/AddUserFormContainer';
import PopoutItem from 'components/PopoutItem/PopoutItem';
import styles from '../InstanceButtonItem.styles';

const propTypes = {
  open: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    actionButton: PropTypes.string.isRequired,
    popoutIconContainer: PropTypes.string.isRequired,
    popoutIconLabel: PropTypes.string.isRequired,
  }).isRequired,
  setUiState: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  anchorEl: PropTypes.shape({}).isRequired,
  statusDisplay: PropTypes.string.isRequired,
  instanceService: PropTypes.string.isRequired,
  instanceId: PropTypes.string.isRequired,
  parentDb: PropTypes.string,
  noLabel: PropTypes.bool,
  customClasses: PropTypes.shape({
    button: PropTypes.shape({}),
    popout: PropTypes.shape({}),
    buttonContainer: PropTypes.shape({}),
  }),
};

const defaultProps = {
  parentDb: '',
  noLabel: false,
  customClasses: {
    button: {},
    popout: {},
    buttonContainer: {},
  },
};

export function UnstyledUserInstanceButtonItem({
  open,
  classes,
  setUiState,
  disabled,
  anchorEl,
  statusDisplay,
  instanceService,
  instanceId,
  parentDb,
  noLabel,
  customClasses,
}) {
  function handleClick(e) {
    e.stopPropagation();

    setUiState({
      open: !open,
      anchorEl: e.currentTarget,
    });
  }

  const theButton = (
    <div style={customClasses.buttonContainer} className={classes.instanceButtonItemContainer}>
      <Button
        style={customClasses.button}
        disabled={disabled}
        onClick={handleClick}
        classes={{ root: classes.zeroPadding, text: classes.zeroPadding }}
        className={classes.actionButton}
        id="userformpopout-button"
      >
        <div className={classes.popoutIconContainer}>
          <PersonAdd
            style={customClasses.popout}
            disabled={disabled}
            className={classes.popoutIcon}
          />
          {!noLabel && <span className={classes.popoutIconLabel}>Users</span>}
        </div>
      </Button>
      <PopoutItem
        anchorEl={anchorEl}
        handleClick={handleClick}
        handleClickAway={(e) => handleClickAway(e, anchorEl, () => setUiState({ open: false }))}
        placement="bottom-end"
        open={open}
        popperId="userformpopout"
      >
        <AddUserFormContainer
          instanceId={instanceId}
          instanceService={instanceService}
          closePopout={() => setUiState({ open: false })}
          parentDb={parentDb}
        />
      </PopoutItem>
    </div>
  );

  let buttonItem;

  if (disabled && statusDisplay === 'Ready') {
    buttonItem = (
      <Tooltip
        title="You do not have the required access for this resource. Contact your organization owner."
        classes={{ tooltip: classes.tooltip }}
      >
        {theButton}
      </Tooltip>
    );
  } else if (noLabel) {
    buttonItem = (
      <Tooltip placement="left" title="Add User" classes={{ tooltip: classes.tooltip }}>
        {theButton}
      </Tooltip>
    );
  } else {
    buttonItem = theButton;
  }

  return buttonItem;
}

UnstyledUserInstanceButtonItem.propTypes = propTypes;
UnstyledUserInstanceButtonItem.defaultProps = defaultProps;

export const uiConfig = {
  name: 'userformpopoutitem',
  state: () => ({
    open: false,
    anchorEl: {},
  }),
};

export default uiState(uiConfig)(withStyles(styles)(UnstyledUserInstanceButtonItem));
